import { call, put, takeLatest } from 'redux-saga/effects';
import HeroSmsAppLink from 'api-services/HeroSmsAppLink';
import { isSuccessResponse } from 'api-services/types/guards';
import { sendSmsAppLinkDone, sendSmsAppLinkError } from './actionCreators';
import { SEND_SMS_APP_LINK } from './actionTypes';
import { logout } from '../auth/actionCreators';
export function* sendSmsAppLink(constAccessParams, action) {
    const result = yield call(HeroSmsAppLink.send, constAccessParams, action.data.mobile);
    if (isSuccessResponse(result)) {
        yield put(sendSmsAppLinkDone(action.data));
    }
    else if (result.statusCode === 4) {
        yield put(logout());
    }
    else {
        yield put(sendSmsAppLinkError(result.msg));
    }
}
export function* watchSendSmsAppLinkCalls(constAccessParams) {
    yield takeLatest(SEND_SMS_APP_LINK, sendSmsAppLink, constAccessParams);
}
//# sourceMappingURL=saga.js.map